import { Route, Routes, Navigate } from "react-router-dom";
import { RequireAuthWrapper } from "../pages/RequireAuthWrapper";
import { CampaignSetupPage } from "../pages/campaignSetupPage";
import { CampaignHomePage } from "../pages/campaignHomePage";
import { AdminCampaignPage } from "../pages/adminCampaignPage";
import { CampaignSummaryPage } from "../pages/campaignSummaryPage";
import { Approval } from "../pages/adminCampaignPage/approval/Approval";
import { CampaignAdminOverview } from "../pages/adminCampaignPage/campaignAdminOverview/CampaignAdminOverview";
import { CampaignInsightsPage } from "../pages/campaignInsightsPage";
import { PreCampaignChecks } from "../pages/adminCampaignPage/preCampaignChecks/PreCampaignChecks";
import { ActiveCampaign } from "../pages/adminCampaignPage/activeCampaign/ActiveCampaign";
import { CampaignInsightsOverview } from "../pages/campaignInsightsPage/campaignInsightsOverview";
import { CampaignInsightDetails } from "../pages/campaignInsightsPage/campaignInsightsDetails";
import { SpecificSegmentRotation } from "../pages/adminCampaignPage/specificSegmentRotation/SpecificSegmentRotation";
import { PermissionsWrapper } from "../pages/PermissionsWrapper";
import { BuyerHomePage } from "../pages/buyerHomePage";
import { SegmentInputDetails } from "../pages/adminCampaignPage/campaignDetails/segmentInputDetails";
import { useReactiveVar } from "@apollo/client";
import { userDetailsVar } from "../lib/cache";
import { BrandChoicesEnum } from "../graphqlExternal/generated";
import { BuyerInsights } from "../pages/buyerInsightsHomePage";

export const insightsOnlyAdvertisersUsers = [BrandChoicesEnum.Bayer];

export const CamapignRoutes = () => {
  const currentUser = useReactiveVar(userDetailsVar);

  return (
    <Routes>
      <Route path={""}>
        <Route
          path={""}
          element={
            <RequireAuthWrapper>
              <BuyerHomePage />
            </RequireAuthWrapper>
          }
        >
          <Route
            path={""}
            element={
              <Navigate
                to={
                  currentUser?.isStaff ||
                  insightsOnlyAdvertisersUsers.includes(
                    currentUser?.agency.name as BrandChoicesEnum
                  )
                    ? "brand-safety-insights"
                    : "all-campaigns"
                }
                replace={true}
              />
            }
          />
          <Route
            path={"brand-safety-insights"}
            element={
              <RequireAuthWrapper>
                <PermissionsWrapper
                  allowedAdvertisers={insightsOnlyAdvertisersUsers}
                >
                  <BuyerInsights />
                </PermissionsWrapper>
              </RequireAuthWrapper>
            }
          />
          <Route
            path={"all-campaigns"}
            element={
              <RequireAuthWrapper>
                <CampaignHomePage />
              </RequireAuthWrapper>
            }
          />
          <Route
            path={"new"}
            element={
              <RequireAuthWrapper>
                <CampaignSetupPage />
              </RequireAuthWrapper>
            }
          />
          <Route path={":id"}>
            <Route
              path={""}
              element={
                <RequireAuthWrapper>
                  <CampaignSummaryPage />
                </RequireAuthWrapper>
              }
            />
            <Route
              path={"admin-campaign"}
              element={
                <RequireAuthWrapper>
                  <PermissionsWrapper mustBeStaff={true}>
                    <AdminCampaignPage />
                  </PermissionsWrapper>
                </RequireAuthWrapper>
              }
            >
              <Route
                path={""}
                element={
                  <Navigate to={"campaign-admin-overview"} replace={true} />
                }
              />
              <Route
                path={"campaign-admin-overview"}
                element={
                  <RequireAuthWrapper>
                    <CampaignAdminOverview />
                  </RequireAuthWrapper>
                }
              />
              <Route
                path={"approval"}
                element={
                  <RequireAuthWrapper>
                    <Approval />
                  </RequireAuthWrapper>
                }
              />
              <Route
                path={"pre-campaign-checks"}
                element={
                  <RequireAuthWrapper>
                    <PreCampaignChecks />
                  </RequireAuthWrapper>
                }
              />
              <Route
                path={"active-campaign"}
                element={
                  <RequireAuthWrapper>
                    <ActiveCampaign />
                  </RequireAuthWrapper>
                }
              />
              <Route
                path={"specific-segment-rotation"}
                element={
                  <RequireAuthWrapper>
                    <SpecificSegmentRotation />
                  </RequireAuthWrapper>
                }
              />
              <Route
                path={"segment-input-details"}
                element={
                  <RequireAuthWrapper>
                    <SegmentInputDetails />
                  </RequireAuthWrapper>
                }
              />
            </Route>
            <Route
              path={"insights"}
              element={
                <RequireAuthWrapper>
                  <CampaignInsightsPage />
                </RequireAuthWrapper>
              }
            >
              <Route
                path={""}
                element={<Navigate to={"overview"} replace={true} />}
              />
              <Route
                path={"overview"}
                element={
                  <RequireAuthWrapper>
                    <CampaignInsightsOverview />{" "}
                  </RequireAuthWrapper>
                }
              />
              <Route
                path={"details"}
                element={
                  <RequireAuthWrapper>
                    <CampaignInsightDetails />
                  </RequireAuthWrapper>
                }
              />
            </Route>
          </Route>
        </Route>
      </Route>
    </Routes>
  );
};
